module.exports = __webpack_public_path__ + "img/penguin_birthday.0194118e.svg";